import { API_URL } from '../../../app-config/constants';
import type ObjectivePreviewDto from '../../../types/ObjectivePreviewDto';
import { get } from '../request';

getObjective.operation = 'READ';
getObjective.byId = true;
export function getObjective(objectiveId: string) {
    return get<ObjectivePreviewDto>(`${API_URL}/objective-preview/${objectiveId}`);
}
